/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { apiGetPayType } from '@/api/miniApp';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import UTable from '@ultra/share/components/UTable/index.vue';
import PayMethod from './payMethod.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    gid: {
      type: Number,
      required: true,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const currentMethod = ref();
    const activeCard = ref('payMethod');
    const miniPanes = computed(() => {
      return [{
        title: '支付方式',
        key: 'payMethod'
      }, {
        title: currentMethod.value ? '更新支付' : '新增支付',
        key: 'updateMethod'
      }];
    });
    const columns = [{
      label: '名称',
      prop: 'name'
    }, {
      label: '支付类型',
      prop: 'type',
      slot: 'type'
    }, {
      label: '支付跳转',
      prop: 'val'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = () => {
      tableLoading.value = true;
      apiGetPayType({
        game_id: props.gid,
        page: current.value,
        page_size: pageSize.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data.list;
          total.value = res.data.total;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSearch
    } = UseTable(getTableData);
    const handleClick = (type, data) => {
      switch (type) {
        case 'edit':
          currentMethod.value = data;
          activeCard.value = 'updateMethod';
          break;
        case 'add':
          activeCard.value = 'updateMethod';
          break;
        default:
          break;
      }
    };
    const handleSuccess = () => {
      activeCard.value = 'payMethod';
      handleSearch();
    };
    onMounted(() => {
      getTableData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_u_card, {
        modelValue: _unref(activeCard),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(activeCard) ? activeCard.value = $event : null),
        panes: _unref(miniPanes)
      }, {
        extra: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_createTextVNode("新增支付")]),
          _: 1
        }, 512), [[_vShow, _unref(activeCard) === 'payMethod']])]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "payMethod"
        }, {
          default: _withCtx(() => [_createVNode(UTable, {
            options: columns,
            "row-key": "cid",
            pagination: "",
            data: _unref(tableData),
            loading: _unref(tableLoading)
          }, {
            type: _withCtx(({
              scope
            }) => [_createTextVNode(_toDisplayString(scope.row.type == 1 ? '客服' : '小程序'), 1)]),
            action: _withCtx(({
              scope
            }) => [_createVNode(_component_el_button, {
              onClick: $event => handleClick('edit', scope.row),
              type: "primary",
              link: ""
            }, {
              default: _withCtx(() => [_createTextVNode("修改")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }, 8, ["data", "loading"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "updateMethod"
        }, {
          default: _withCtx(() => [_createVNode(PayMethod, {
            gid: __props.gid,
            data: _unref(currentMethod),
            onSuccess: handleSuccess
          }, null, 8, ["gid", "data"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "panes"])]);
    };
  }
});